// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleGroup_backButton__wpjjU {
  align-items: center;
  column-gap: 16px;
  display: flex;
  height: 32px;
  width: fit-content;
}
.SingleGroup_backButtonArrow__du6V3 {
  cursor: pointer;
  fill: #7e818c;
  transition: fill 200ms ease-in-out;
}
.SingleGroup_backButton__wpjjU:hover .SingleGroup_backButtonArrow__du6V3 {
  fill: #cb9c2d;
  transition: fill 200ms ease-in-out;
}
.SingleGroup_backButtonText__AN5D9 {
  color: #7e818c;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  transition: color 200ms ease-in-out;
}
.SingleGroup_backButton__wpjjU:hover .SingleGroup_backButtonText__AN5D9 {
  color: #cb9c2d;
  cursor: pointer;
  transition: color 200ms ease-in-out;
}
.SingleGroup_groupHeadContainer__NLM4V {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px 0px 48px;
}
.SingleGroup_groupHeadTextContainer__XOn7b {
  cursor: default;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.SingleGroup_groupTitle__VDlyM {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin: 0px;
  display: flex;
  align-items: center;
}
.SingleGroup_groupHeadButtonsContainer__qWh7h {
  display: flex;
  column-gap: 10px;
}

.SingleGroup_groupHeadTitleContainer__YWoLm {
  display: flex;
  gap: 8px;
}
.SingleGroup_deleteGroupButton__LRJfF {
  background-color: #cb2d2d;
}
.SingleGroup_deleteGroupButtonIcon__vzkTX {
  width: 24px;
  height: 24px;
}
.SingleGroup_deleteGroupButton__LRJfF,
.SingleGroup_introspectionsButton__v5au0,
.SingleGroup_deleteBtn__KKEUO {
  border-radius: 4px;
  column-gap: 8px;
  cursor: pointer;
  height: 52px;
  width: 228px;
}
.SingleGroup_introspectionsButton__v5au0 {
  background-color: #cb9c2d;
}
.SingleGroup_deleteBtn__KKEUO {
  background-color: #cb2d2d;
}
.SingleGroup_deleteBtn__KKEUO:hover {
  background-color: #aa2828;
}
.SingleGroup_introspectionsButton__v5au0,
.SingleGroup_introspectionsButtonDisabled__FAyWx,
.SingleGroup_moreButton__TdyK5,
.SingleGroup_moreButtonDisabled__3oxe-,
.SingleGroup_teachersCardCarouselButtons__a5Byg,
.SingleGroup_addCard__EBQCC,
.SingleGroup_removeItemButton__hxGZ1,
.SingleGroup_cancelButton__Vrw0t,
.SingleGroup_saveButton__16IEG,
.SingleGroup_duplicateModalContainer__E\\+tVD,
.SingleGroup_modalCancelButton__-v3FD,
.SingleGroup_modalSaveButton__FMQHS,
.SingleGroup_deleteGroupButton__LRJfF,
.SingleGroup_deleteBtn__KKEUO {
  display: flex;
  align-items: center;
  justify-content: center;
}
.SingleGroup_introspectionsButton__v5au0:hover {
  background-color: #9b7722;
}
.SingleGroup_introspectionsButtonDisabled__FAyWx {
  border-radius: 4px;
  background-color: #cb9c2d;
  column-gap: 8px;
  cursor: not-allowed;
  height: 52px;
  opacity: 0.5;
  width: 228px;
}
.SingleGroup_introspectionsButtonIcon__2Aq-B {
  stroke: #ffffff;
}
.SingleGroup_moreButton__TdyK5 {
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  color: #cb9c2d;
  column-gap: 8px;
  cursor: pointer;
  height: 52px;
  width: 228px;
}
.SingleGroup_moreButton__TdyK5:hover {
  background-color: #d8d9da;
  transition: 300ms ease-in-out background-color;
}
.SingleGroup_moreButtonDisabled__3oxe- {
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  color: #cb9c2d;
  column-gap: 8px;
  cursor: not-allowed;
  height: 52px;
  opacity: 0.5;
  width: 228px;
}
.SingleGroup_moreButtonText__luKmI {
  color: #5f6d7e;
}
.SingleGroup_introspectionsButtonText__9ufSQ {
  color: #ffffff;
}
.SingleGroup_modalButtons__rnLr\\+,
.SingleGroup_groupDateText__ydon0,
.SingleGroup_introspectionsButtonText__9ufSQ,
.SingleGroup_saveButtonText__nqiv-,
.SingleGroup_modalButtonText__Zr5P5,
.SingleGroup_deleteBtnText__a\\+KLp {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.SingleGroup_saveButtonText__nqiv-,
.SingleGroup_modalButtonText__Zr5P5,
.SingleGroup_deleteBtnText__a\\+KLp {
  color: #ffffff;
}
.SingleGroup_groupDateText__ydon0 {
  color: #818c99;
  cursor: default;
}
.SingleGroup_moreButtonIcon__oWgOs {
  stroke: #000000;
}
.SingleGroup_dropdownContainer__YLXnx {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 17px 0px rgba(95, 109, 126, 0.16);
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px 0px;
  position: absolute;
  width: 228px;
  z-index: 1;
}
.SingleGroup_dropdownItem__iGEq2 {
  cursor: pointer;
  display: flex;
  padding: 12px 16px;
  transition: all 250ms ease-in-out;
}
.SingleGroup_dropdownItem__iGEq2:hover {
  background-color: #f2f2f2;
}
.SingleGroup_text__dW4Xu {
  color: #5f6d7e;
}
.SingleGroup_text__dW4Xu,
.SingleGroup_deleteText__aH6fI {
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.SingleGroup_deleteText__aH6fI {
  color: #cb2d2d;
  text-transform: capitalize;
}
.SingleGroup_leadersContainer__N7tO1 {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
.SingleGroup_leadersTitleContainer__8Pqm6 {
  display: flex;
  column-gap: 8px;
  align-items: center;
}
.SingleGroup_leadersTitle__s8Fbd {
  color: #4d4d4d;
  cursor: default;
  margin: 0px;
  font-size: 20px;
}
.SingleGroup_cardsContainer__I0dP1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  width: 100%;
  height: 330px;
  position: relative;
  padding-left: 15px;
}
.SingleGroup_teachersCard__cLCgt {
  /* width: calc(70% / 4); */
  min-width: 230px;
  flex: 0 0 auto;
  transition: transform 300ms;
}

.SingleGroup_teachersCard__cLCgt:hover {
  cursor: pointer;
}
.SingleGroup_teachersCard__cLCgt.SingleGroup_active__eZLz9 {
  border-radius: 16px;
}
.SingleGroup_teachersCard__cLCgt.SingleGroup_hidden__ZLB7E {
  opacity: 0;
  pointer-events: none;
}
.SingleGroup_teachersCardCarouselButtons__a5Byg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.SingleGroup_spacer__uNdeH {
  flex: 1 1;
}
.SingleGroup_teachersCardNextBtn__PhCtU {
  width: 64px;
  height: 64px;
  padding: 16px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 300ms ease;
}
.SingleGroup_teachersCardNextBtn__PhCtU:hover {
  background-color: #f8f9fb;
}
.SingleGroup_addCard__EBQCC {
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  cursor: pointer;
  flex-direction: column;
  height: 218.5px;
  padding: 16px;
  row-gap: 8px;
  width: 173px;
  z-index: 2;
}
.SingleGroup_addCardIcon__1lBfY {
  height: 24px;
  stroke: #828d9a;
  width: 24px;
}
.SingleGroup_attendeesContainer__khtXg {
  display: flex;
  flex-direction: column;
  margin: 53px 0px 40px;
  row-gap: 24px;
}
.SingleGroup_attendeesTitleContainer__psaaK {
  display: flex;
  column-gap: 8px;
  align-items: center;
}
.SingleGroup_attendeesTitle__ein\\+P {
  color: #4d4d4d;
  cursor: default;
  font-size: 20px;
}
.SingleGroup_attendeesNumber__\\+y310,
.SingleGroup_leadersNumber__EA7e\\+ {
  color: #9fa7b2;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 1px 0px 0px 0px;
}
.SingleGroup_editContainer__pSa-1 {
  column-gap: 24px;
  display: flex;
  margin-bottom: 40px;
  width: 100%;
}
.SingleGroup_editContainerBox__5G4Rk {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
}
.SingleGroup_colorsContainer__qawYr {
  display: flex;
  justify-content: space-between;
}
.SingleGroup_colorContainer__v86uW {
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  row-gap: 8px;
  width: 100%;
}

.SingleGroup_colorBox__YGkaL {
  align-items: center;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 46px;
  padding: 0px 16px;
  row-gap: 8px;
}
.SingleGroup_color__ggBh7 {
  border: 1px solid #d8dbdf;
  border-radius: 4px;
  display: flex;
  height: 22px;
  width: 100%;
}
.SingleGroup_removeItemButton__hxGZ1 {
  background-color: #e2e2e2;
  border-radius: 64px;
  cursor: pointer;
  height: 32px;
  margin: -16px 0px 0px 191px;
  position: absolute;
  width: 32px;
  z-index: 2;
}
.SingleGroup_removeItemIcon__gH3Q\\+ {
  height: 16px;
  stroke: #5f6d7e;
  width: 16px;
}
.SingleGroup_editActionsButtons__OEnQW {
  column-gap: 8px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.SingleGroup_cancelButton__Vrw0t {
  background-color: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
  width: 212px;
}
.SingleGroup_addCardText__1eF-w {
  color: #828d9a;
}
.SingleGroup_cancelButtonText__SNSD3,
.SingleGroup_modalCancelText__vSi5B,
.SingleGroup_colorLabel__2d6n0,
.SingleGroup_addCardIcon__1lBfY,
.SingleGroup_attendeesTitle__ein\\+P,
.SingleGroup_leadersTitle__s8Fbd {
  font-family: Inter;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.SingleGroup_cancelButtonText__SNSD3,
.SingleGroup_modalCancelText__vSi5B,
.SingleGroup_colorLabel__2d6n0,
.SingleGroup_addCardIcon__1lBfY {
  font-size: 16px;
}

.SingleGroup_cancelButtonText__SNSD3,
.SingleGroup_modalCancelText__vSi5B {
  color: #808080;
}
.SingleGroup_colorLabel__2d6n0 {
  color: #5f6d7e;
}
.SingleGroup_cancelButtonText__SNSD3,
.SingleGroup_saveButtonText__nqiv- {
  text-transform: capitalize;
}
.SingleGroup_saveButton__16IEG {
  background-color: #cb9c2d;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
  width: 212px;
}

.SingleGroup_colorPickIconBox__TJIwF {
  cursor: pointer;
  margin: -33px 0px 0px 195px;
  position: absolute;
}
.SingleGroup_colorPickIcon__3KoXj {
  height: 18px;
  stroke: #5f6d7e;
  width: 18px;
}
.SingleGroup_duplicateModalContainer__E\\+tVD {
  background-color: #fff;
  border-radius: 16px;
  flex-direction: column;
  height: 354px;
  width: 640px;
}
.SingleGroup_duplicateModalTitle__87u-o {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin: 0px 0px 48px;
}
.SingleGroup_modalButtons__rnLr\\+ {
  column-gap: 8px;
  display: flex;
  justify-content: center;
  margin-top: 64px;
  width: 100%;
}
.SingleGroup_modalInputContainer__VfroB {
  width: 480px;
}
.SingleGroup_modalCancelButton__-v3FD {
  background-color: #ebebeb;
}
.SingleGroup_modalCancelButton__-v3FD:hover {
  background-color: #c7c5c5;
}
.SingleGroup_modalCancelButton__-v3FD:hover,
.SingleGroup_modalSaveButton__FMQHS:hover {
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.SingleGroup_modalSaveButton__FMQHS {
  background-color: #cb9c2d;
}
.SingleGroup_modalSaveButton__FMQHS:hover {
  background-color: #b48b29;
}
.SingleGroup_modalSaveButton__FMQHS,
.SingleGroup_modalCancelButton__-v3FD {
  border-radius: 4px;
  height: 52px;
  width: 212px;
}

@media screen and (max-width: 900px) {
  .SingleGroup_groupHeadContainer__NLM4V,
  .SingleGroup_groupHeadButtonsContainer__qWh7h {
    flex-direction: column;
    gap: 24px;
  }
  .SingleGroup_groupHeadButtonsContainer__qWh7h {
    align-items: center;
    justify-content: center;
  }
  .SingleGroup_introspectionsButton__v5au0,
  .SingleGroup_moreButtonContainer__49TJp,
  .SingleGroup_deleteGroupButton__LRJfF,
  .SingleGroup_moreButtonDisabled__3oxe-,
  .SingleGroup_introspectionsButtonDisabled__FAyWx {
    width: 50%;
  }
  .SingleGroup_dropdownContainer__YLXnx {
    width: 45%;
  }
  .SingleGroup_moreButtonDisabled__3oxe-,
  .SingleGroup_moreButton__TdyK5 {
    width: 100%;
  }
  .SingleGroup_editContainer__pSa-1,
  .SingleGroup_colorsContainer__qawYr {
    flex-direction: column;
    gap: 24px;
  }
}

@media screen and (max-width: 500px) {
  .SingleGroup_introspectionsButton__v5au0,
  .SingleGroup_moreButtonContainer__49TJp,
  .SingleGroup_deleteGroupButton__LRJfF,
  .SingleGroup_introspectionsButtonDisabled__FAyWx {
    width: 70%;
  }
  .SingleGroup_dropdownContainer__YLXnx {
    width: 63%;
  }
}

@media screen and (min-width: 320px) and (max-width: 425px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(300% / 5);
  }
}
@media screen and (min-width: 425px) and (max-width: 575px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(235% / 5);
  }
}
@media screen and (min-width: 575px) and (max-width: 680px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(170% / 5);
  }
}
@media screen and (min-width: 680px) and (max-width: 768px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(150% / 5);
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(130% / 5);
  }
}
@media screen and (min-width: 1024px) and (max-width: 1328px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(100% / 5);
  }
}
@media screen and (min-width: 1328px) {
  .SingleGroup_teachersCard__cLCgt {
    width: calc(70% / 5);
  }
}
@media screen and (max-width: 430px) {
  .SingleGroup_introspectionsButton__v5au0,
  .SingleGroup_moreButtonContainer__49TJp,
  .SingleGroup_deleteGroupButton__LRJfF,
  .SingleGroup_moreButtonDisabled__3oxe-,
  .SingleGroup_introspectionsButtonDisabled__FAyWx {
    width: 100%;
  }
  .SingleGroup_dropdownContainer__YLXnx {
    width: 90%;
  }
}

@media screen and (max-width: 800px) {
  .SingleGroup_cardsContainer__I0dP1 {
    overflow-x: scroll;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/singleGroup/SingleGroup.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;EAcE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;;IAEE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;;;;IAKE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;;;;IAIE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;;;;;IAKE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".backButton {\n  align-items: center;\n  column-gap: 16px;\n  display: flex;\n  height: 32px;\n  width: fit-content;\n}\n.backButtonArrow {\n  cursor: pointer;\n  fill: #7e818c;\n  transition: fill 200ms ease-in-out;\n}\n.backButton:hover .backButtonArrow {\n  fill: #cb9c2d;\n  transition: fill 200ms ease-in-out;\n}\n.backButtonText {\n  color: #7e818c;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  transition: color 200ms ease-in-out;\n}\n.backButton:hover .backButtonText {\n  color: #cb9c2d;\n  cursor: pointer;\n  transition: color 200ms ease-in-out;\n}\n.groupHeadContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 24px 0px 48px;\n}\n.groupHeadTextContainer {\n  cursor: default;\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.groupTitle {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n.groupHeadButtonsContainer {\n  display: flex;\n  column-gap: 10px;\n}\n\n.groupHeadTitleContainer {\n  display: flex;\n  gap: 8px;\n}\n.deleteGroupButton {\n  background-color: #cb2d2d;\n}\n.deleteGroupButtonIcon {\n  width: 24px;\n  height: 24px;\n}\n.deleteGroupButton,\n.introspectionsButton,\n.deleteBtn {\n  border-radius: 4px;\n  column-gap: 8px;\n  cursor: pointer;\n  height: 52px;\n  width: 228px;\n}\n.introspectionsButton {\n  background-color: #cb9c2d;\n}\n.deleteBtn {\n  background-color: #cb2d2d;\n}\n.deleteBtn:hover {\n  background-color: #aa2828;\n}\n.introspectionsButton,\n.introspectionsButtonDisabled,\n.moreButton,\n.moreButtonDisabled,\n.teachersCardCarouselButtons,\n.addCard,\n.removeItemButton,\n.cancelButton,\n.saveButton,\n.duplicateModalContainer,\n.modalCancelButton,\n.modalSaveButton,\n.deleteGroupButton,\n.deleteBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.introspectionsButton:hover {\n  background-color: #9b7722;\n}\n.introspectionsButtonDisabled {\n  border-radius: 4px;\n  background-color: #cb9c2d;\n  column-gap: 8px;\n  cursor: not-allowed;\n  height: 52px;\n  opacity: 0.5;\n  width: 228px;\n}\n.introspectionsButtonIcon {\n  stroke: #ffffff;\n}\n.moreButton {\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  color: #cb9c2d;\n  column-gap: 8px;\n  cursor: pointer;\n  height: 52px;\n  width: 228px;\n}\n.moreButton:hover {\n  background-color: #d8d9da;\n  transition: 300ms ease-in-out background-color;\n}\n.moreButtonDisabled {\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  color: #cb9c2d;\n  column-gap: 8px;\n  cursor: not-allowed;\n  height: 52px;\n  opacity: 0.5;\n  width: 228px;\n}\n.moreButtonText {\n  color: #5f6d7e;\n}\n.introspectionsButtonText {\n  color: #ffffff;\n}\n.modalButtons,\n.groupDateText,\n.introspectionsButtonText,\n.saveButtonText,\n.modalButtonText,\n.deleteBtnText {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.saveButtonText,\n.modalButtonText,\n.deleteBtnText {\n  color: #ffffff;\n}\n.groupDateText {\n  color: #818c99;\n  cursor: default;\n}\n.moreButtonIcon {\n  stroke: #000000;\n}\n.dropdownContainer {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 17px 0px rgba(95, 109, 126, 0.16);\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  padding: 8px 0px;\n  position: absolute;\n  width: 228px;\n  z-index: 1;\n}\n.dropdownItem {\n  cursor: pointer;\n  display: flex;\n  padding: 12px 16px;\n  transition: all 250ms ease-in-out;\n}\n.dropdownItem:hover {\n  background-color: #f2f2f2;\n}\n.text {\n  color: #5f6d7e;\n}\n.text,\n.deleteText {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.deleteText {\n  color: #cb2d2d;\n  text-transform: capitalize;\n}\n.leadersContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n}\n.leadersTitleContainer {\n  display: flex;\n  column-gap: 8px;\n  align-items: center;\n}\n.leadersTitle {\n  color: #4d4d4d;\n  cursor: default;\n  margin: 0px;\n  font-size: 20px;\n}\n.cardsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n  width: 100%;\n  height: 330px;\n  position: relative;\n  padding-left: 15px;\n}\n.teachersCard {\n  /* width: calc(70% / 4); */\n  min-width: 230px;\n  flex: 0 0 auto;\n  transition: transform 300ms;\n}\n\n.teachersCard:hover {\n  cursor: pointer;\n}\n.teachersCard.active {\n  border-radius: 16px;\n}\n.teachersCard.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n.teachersCardCarouselButtons {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.spacer {\n  flex: 1;\n}\n.teachersCardNextBtn {\n  width: 64px;\n  height: 64px;\n  padding: 16px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color 300ms ease;\n}\n.teachersCardNextBtn:hover {\n  background-color: #f8f9fb;\n}\n.addCard {\n  border: 1px solid #e2e2e2;\n  border-radius: 8px;\n  cursor: pointer;\n  flex-direction: column;\n  height: 218.5px;\n  padding: 16px;\n  row-gap: 8px;\n  width: 173px;\n  z-index: 2;\n}\n.addCardIcon {\n  height: 24px;\n  stroke: #828d9a;\n  width: 24px;\n}\n.attendeesContainer {\n  display: flex;\n  flex-direction: column;\n  margin: 53px 0px 40px;\n  row-gap: 24px;\n}\n.attendeesTitleContainer {\n  display: flex;\n  column-gap: 8px;\n  align-items: center;\n}\n.attendeesTitle {\n  color: #4d4d4d;\n  cursor: default;\n  font-size: 20px;\n}\n.attendeesNumber,\n.leadersNumber {\n  color: #9fa7b2;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 1px 0px 0px 0px;\n}\n.editContainer {\n  column-gap: 24px;\n  display: flex;\n  margin-bottom: 40px;\n  width: 100%;\n}\n.editContainerBox {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n  width: 100%;\n}\n.colorsContainer {\n  display: flex;\n  justify-content: space-between;\n}\n.colorContainer {\n  display: flex;\n  flex-direction: column;\n  margin-right: 8px;\n  row-gap: 8px;\n  width: 100%;\n}\n\n.colorBox {\n  align-items: center;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  height: 46px;\n  padding: 0px 16px;\n  row-gap: 8px;\n}\n.color {\n  border: 1px solid #d8dbdf;\n  border-radius: 4px;\n  display: flex;\n  height: 22px;\n  width: 100%;\n}\n.removeItemButton {\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  cursor: pointer;\n  height: 32px;\n  margin: -16px 0px 0px 191px;\n  position: absolute;\n  width: 32px;\n  z-index: 2;\n}\n.removeItemIcon {\n  height: 16px;\n  stroke: #5f6d7e;\n  width: 16px;\n}\n.editActionsButtons {\n  column-gap: 8px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.cancelButton {\n  background-color: #ebebeb;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n  width: 212px;\n}\n.addCardText {\n  color: #828d9a;\n}\n.cancelButtonText,\n.modalCancelText,\n.colorLabel,\n.addCardIcon,\n.attendeesTitle,\n.leadersTitle {\n  font-family: Inter;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.cancelButtonText,\n.modalCancelText,\n.colorLabel,\n.addCardIcon {\n  font-size: 16px;\n}\n\n.cancelButtonText,\n.modalCancelText {\n  color: #808080;\n}\n.colorLabel {\n  color: #5f6d7e;\n}\n.cancelButtonText,\n.saveButtonText {\n  text-transform: capitalize;\n}\n.saveButton {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n  width: 212px;\n}\n\n.colorPickIconBox {\n  cursor: pointer;\n  margin: -33px 0px 0px 195px;\n  position: absolute;\n}\n.colorPickIcon {\n  height: 18px;\n  stroke: #5f6d7e;\n  width: 18px;\n}\n.duplicateModalContainer {\n  background-color: #fff;\n  border-radius: 16px;\n  flex-direction: column;\n  height: 354px;\n  width: 640px;\n}\n.duplicateModalTitle {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin: 0px 0px 48px;\n}\n.modalButtons {\n  column-gap: 8px;\n  display: flex;\n  justify-content: center;\n  margin-top: 64px;\n  width: 100%;\n}\n.modalInputContainer {\n  width: 480px;\n}\n.modalCancelButton {\n  background-color: #ebebeb;\n}\n.modalCancelButton:hover {\n  background-color: #c7c5c5;\n}\n.modalCancelButton:hover,\n.modalSaveButton:hover {\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.modalSaveButton {\n  background-color: #cb9c2d;\n}\n.modalSaveButton:hover {\n  background-color: #b48b29;\n}\n.modalSaveButton,\n.modalCancelButton {\n  border-radius: 4px;\n  height: 52px;\n  width: 212px;\n}\n\n@media screen and (max-width: 900px) {\n  .groupHeadContainer,\n  .groupHeadButtonsContainer {\n    flex-direction: column;\n    gap: 24px;\n  }\n  .groupHeadButtonsContainer {\n    align-items: center;\n    justify-content: center;\n  }\n  .introspectionsButton,\n  .moreButtonContainer,\n  .deleteGroupButton,\n  .moreButtonDisabled,\n  .introspectionsButtonDisabled {\n    width: 50%;\n  }\n  .dropdownContainer {\n    width: 45%;\n  }\n  .moreButtonDisabled,\n  .moreButton {\n    width: 100%;\n  }\n  .editContainer,\n  .colorsContainer {\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .introspectionsButton,\n  .moreButtonContainer,\n  .deleteGroupButton,\n  .introspectionsButtonDisabled {\n    width: 70%;\n  }\n  .dropdownContainer {\n    width: 63%;\n  }\n}\n\n@media screen and (min-width: 320px) and (max-width: 425px) {\n  .teachersCard {\n    width: calc(300% / 5);\n  }\n}\n@media screen and (min-width: 425px) and (max-width: 575px) {\n  .teachersCard {\n    width: calc(235% / 5);\n  }\n}\n@media screen and (min-width: 575px) and (max-width: 680px) {\n  .teachersCard {\n    width: calc(170% / 5);\n  }\n}\n@media screen and (min-width: 680px) and (max-width: 768px) {\n  .teachersCard {\n    width: calc(150% / 5);\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .teachersCard {\n    width: calc(130% / 5);\n  }\n}\n@media screen and (min-width: 1024px) and (max-width: 1328px) {\n  .teachersCard {\n    width: calc(100% / 5);\n  }\n}\n@media screen and (min-width: 1328px) {\n  .teachersCard {\n    width: calc(70% / 5);\n  }\n}\n@media screen and (max-width: 430px) {\n  .introspectionsButton,\n  .moreButtonContainer,\n  .deleteGroupButton,\n  .moreButtonDisabled,\n  .introspectionsButtonDisabled {\n    width: 100%;\n  }\n  .dropdownContainer {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .cardsContainer {\n    overflow-x: scroll;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backButton": `SingleGroup_backButton__wpjjU`,
	"backButtonArrow": `SingleGroup_backButtonArrow__du6V3`,
	"backButtonText": `SingleGroup_backButtonText__AN5D9`,
	"groupHeadContainer": `SingleGroup_groupHeadContainer__NLM4V`,
	"groupHeadTextContainer": `SingleGroup_groupHeadTextContainer__XOn7b`,
	"groupTitle": `SingleGroup_groupTitle__VDlyM`,
	"groupHeadButtonsContainer": `SingleGroup_groupHeadButtonsContainer__qWh7h`,
	"groupHeadTitleContainer": `SingleGroup_groupHeadTitleContainer__YWoLm`,
	"deleteGroupButton": `SingleGroup_deleteGroupButton__LRJfF`,
	"deleteGroupButtonIcon": `SingleGroup_deleteGroupButtonIcon__vzkTX`,
	"introspectionsButton": `SingleGroup_introspectionsButton__v5au0`,
	"deleteBtn": `SingleGroup_deleteBtn__KKEUO`,
	"introspectionsButtonDisabled": `SingleGroup_introspectionsButtonDisabled__FAyWx`,
	"moreButton": `SingleGroup_moreButton__TdyK5`,
	"moreButtonDisabled": `SingleGroup_moreButtonDisabled__3oxe-`,
	"teachersCardCarouselButtons": `SingleGroup_teachersCardCarouselButtons__a5Byg`,
	"addCard": `SingleGroup_addCard__EBQCC`,
	"removeItemButton": `SingleGroup_removeItemButton__hxGZ1`,
	"cancelButton": `SingleGroup_cancelButton__Vrw0t`,
	"saveButton": `SingleGroup_saveButton__16IEG`,
	"duplicateModalContainer": `SingleGroup_duplicateModalContainer__E+tVD`,
	"modalCancelButton": `SingleGroup_modalCancelButton__-v3FD`,
	"modalSaveButton": `SingleGroup_modalSaveButton__FMQHS`,
	"introspectionsButtonIcon": `SingleGroup_introspectionsButtonIcon__2Aq-B`,
	"moreButtonText": `SingleGroup_moreButtonText__luKmI`,
	"introspectionsButtonText": `SingleGroup_introspectionsButtonText__9ufSQ`,
	"modalButtons": `SingleGroup_modalButtons__rnLr+`,
	"groupDateText": `SingleGroup_groupDateText__ydon0`,
	"saveButtonText": `SingleGroup_saveButtonText__nqiv-`,
	"modalButtonText": `SingleGroup_modalButtonText__Zr5P5`,
	"deleteBtnText": `SingleGroup_deleteBtnText__a+KLp`,
	"moreButtonIcon": `SingleGroup_moreButtonIcon__oWgOs`,
	"dropdownContainer": `SingleGroup_dropdownContainer__YLXnx`,
	"dropdownItem": `SingleGroup_dropdownItem__iGEq2`,
	"text": `SingleGroup_text__dW4Xu`,
	"deleteText": `SingleGroup_deleteText__aH6fI`,
	"leadersContainer": `SingleGroup_leadersContainer__N7tO1`,
	"leadersTitleContainer": `SingleGroup_leadersTitleContainer__8Pqm6`,
	"leadersTitle": `SingleGroup_leadersTitle__s8Fbd`,
	"cardsContainer": `SingleGroup_cardsContainer__I0dP1`,
	"teachersCard": `SingleGroup_teachersCard__cLCgt`,
	"active": `SingleGroup_active__eZLz9`,
	"hidden": `SingleGroup_hidden__ZLB7E`,
	"spacer": `SingleGroup_spacer__uNdeH`,
	"teachersCardNextBtn": `SingleGroup_teachersCardNextBtn__PhCtU`,
	"addCardIcon": `SingleGroup_addCardIcon__1lBfY`,
	"attendeesContainer": `SingleGroup_attendeesContainer__khtXg`,
	"attendeesTitleContainer": `SingleGroup_attendeesTitleContainer__psaaK`,
	"attendeesTitle": `SingleGroup_attendeesTitle__ein+P`,
	"attendeesNumber": `SingleGroup_attendeesNumber__+y310`,
	"leadersNumber": `SingleGroup_leadersNumber__EA7e+`,
	"editContainer": `SingleGroup_editContainer__pSa-1`,
	"editContainerBox": `SingleGroup_editContainerBox__5G4Rk`,
	"colorsContainer": `SingleGroup_colorsContainer__qawYr`,
	"colorContainer": `SingleGroup_colorContainer__v86uW`,
	"colorBox": `SingleGroup_colorBox__YGkaL`,
	"color": `SingleGroup_color__ggBh7`,
	"removeItemIcon": `SingleGroup_removeItemIcon__gH3Q+`,
	"editActionsButtons": `SingleGroup_editActionsButtons__OEnQW`,
	"addCardText": `SingleGroup_addCardText__1eF-w`,
	"cancelButtonText": `SingleGroup_cancelButtonText__SNSD3`,
	"modalCancelText": `SingleGroup_modalCancelText__vSi5B`,
	"colorLabel": `SingleGroup_colorLabel__2d6n0`,
	"colorPickIconBox": `SingleGroup_colorPickIconBox__TJIwF`,
	"colorPickIcon": `SingleGroup_colorPickIcon__3KoXj`,
	"duplicateModalTitle": `SingleGroup_duplicateModalTitle__87u-o`,
	"modalInputContainer": `SingleGroup_modalInputContainer__VfroB`,
	"moreButtonContainer": `SingleGroup_moreButtonContainer__49TJp`
};
export default ___CSS_LOADER_EXPORT___;
